import { Component, Input, OnInit, Output, ViewChild } from '@angular/core';
import { EventEmitter } from '@angular/forms/src/facade/async';
import { T2CardComponent } from '../../../../trip2-theme/components/t2-card/t2-card.component';
import { T2LoadingService } from '../../../../trip2-theme/components/t2-loading/t2-loading.service';
import { ITypeLicense, LicensesService } from '../../../../services/licenses.service';
import { GridOptions } from 'ag-grid';
import { historyLicense } from 'app/core/interfaces/history-license-interface';
import { CategoryTypeLicense } from 'app/core/enums/driver-license.enum';


@Component({
  selector: 'app-licenses-create',
  templateUrl: './licenses-create.component.html',
  styleUrls: ['./licenses-create.component.scss']
})
export class LicensesCreateComponent implements OnInit {

  public tab = 1;
  public idTypeLicense: number;
  public rowDate: historyLicense[] = [];

  gridTipeLicenses: GridOptions;
  data: ITypeLicense;
  title: string;
  @Input() licensesSelected?: any;
  @Output() notify?: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() cancel?: EventEmitter<boolean> = new EventEmitter<boolean>();
  @ViewChild('appLicenseCreate') card: T2CardComponent;
  categoryTypeLicense: any;

  constructor(private _loading: T2LoadingService,
              private loading: T2LoadingService,
    private _serviceLicensesService: LicensesService) {
    this.gridTipeLicenses = <GridOptions>{};
    this.gridTipeLicenses.columnDefs = [
      { headerName: 'Date', field: 'date', width: 73 },
      { headerName: 'Time', field: 'time', width: 52 },
      { headerName: 'Description', field: 'description', width: 363 },
      { headerName: 'User', field: 'userprofiledata.fullname', width: 110 },
    ];
  }


  ngOnInit() {
    if (this.licensesSelected !== null) {
      this.idTypeLicense = this.licensesSelected.typelicenseid;
      this.data = this.licensesSelected;
      this.title = 'Edit License - ' + this.data.description;
      this.data.documentextract = this.isDriverCategory && !!this.data.documentextract;
    }else {
      this.title = 'Add License';
      this.data = <ITypeLicense>{};
      this.data.isactive = true;
      this.data.documentextract = false;
    }
    this.getCategoryTypeLicense();
  }

  historyLicense() {
    this.tab = 2;
    if (this.idTypeLicense) {
      this.loading.show('Loading License History')
      this._serviceLicensesService.getHistoryLicenses(this.idTypeLicense).subscribe((res): void => {
          this.rowDate = res;
          this.gridTipeLicenses.api.setRowData(this.rowDate);
          this.loading.hiden();
        },
        error => {
        })
    }
  }

  get isDriverCategory(): boolean {
    return this.isDriverCategoryId(this.data.categorytypelicenseid);
  }

  onChangeCategory(categoryTypeLicenseId: number | string) {
    if (!this.isDriverCategoryId(categoryTypeLicenseId)) {
      this.data.documentextract = false;
    }
  }

  private isDriverCategoryId(categoryTypeLicenseId: number | string): boolean {
    return +categoryTypeLicenseId === CategoryTypeLicense.Driver;
  }

  sendNotify(data: any) {
    this.notify.emit(data);
  }

  cancelCreateEdit() {
    this.cancel.emit(true);
    this.data = <ITypeLicense>{};
  }

  saveAction() {
    delete this.data.categorytypelicense;
    delete this.data.modifiedon;
    delete this.data.addedon;
    if (this.licensesSelected === null) {
      this._serviceLicensesService.postTypeLicense(this.data).finally(() => {
        this._loading.hiden();
        this.card.viewProgressBar(false);
      }).subscribe(
        res => this.sendNotify(res)
      );
    } else {
      this._serviceLicensesService.putTypeLicense(this.data).finally(() => {
        this._loading.hiden();
        this.card.viewProgressBar(false);
      }).subscribe(
        res => this.sendNotify(res)
      );
    }
  }

  getCategoryTypeLicense() {
    this._serviceLicensesService.getCategoryTypeLicense().subscribe(
      data => {
        this.categoryTypeLicense = data;
      }
    )
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/licenses/components/licenses-create/licenses-create.component.ts